/**
 * dApp sign helpers — challenge fetch + human labels for mid-app Sign UI.
 * Phantom / inject / play session — not Phantom MCP agent wallets.
 */
import type { PlayAction } from "@/lib/signed-action";

export type SignPurpose =
  | PlayAction
  | "p2p_transfer"
  | "custom";

export const SIGN_PURPOSE_LABEL: Record<string, string> = {
  play_session: "Authorize game play",
  table_join: "Join table",
  slots_spin: "Slots spin",
  cashout: "Cash-out request",
  pro_claim: "Claim pro badge",
  p2p_transfer: "Send play GBUX",
  custom: "Sign message",
};

export function purposeTitle(purpose: SignPurpose): string {
  return SIGN_PURPOSE_LABEL[purpose] || "Sign with wallet";
}

export function purposeBlurb(purpose: SignPurpose): string {
  switch (purpose) {
    case "play_session":
      return "One signature authorizes real play GBUX on this dApp for 24 hours (tables, slots, blackjack). Not fake chips — navigate freely until the session expires.";
    case "table_join":
      return "Buy-in debits real play GBUX onto the table. Covered by your 24h play session when active.";
    case "slots_spin":
      return "Spin bets debit real play GBUX. Covered by your play session token.";
    case "cashout":
      return "Confirm a cash-out / swap-out request emailed to games@grudgestudio.org (staff review — no automatic chain send).";
    case "pro_claim":
      return "Prove wallet ownership to claim this Calling Pros badge.";
    case "p2p_transfer":
      return "Server wallet → server wallet only: real play-ledger GBUX to another player by username (not on-chain).";
    default:
      return "Confirm this action with your connected wallet.";
  }
}

export async function fetchActionChallenge(opts: {
  wallet: string;
  action: PlayAction;
  params?: Record<string, string | number | undefined>;
}): Promise<{ message: string; nonce: string; issuedAt: string }> {
  const q = new URLSearchParams({
    action: opts.action,
    wallet: opts.wallet,
  });
  if (opts.params) {
    for (const [k, v] of Object.entries(opts.params)) {
      if (v === undefined || v === null || v === "") continue;
      q.set(k, String(v));
    }
  }
  const h = new Headers({ Accept: "application/json" });
  h.set("X-Wallet-Address", opts.wallet);
  const r = await fetch(`/api/wallet/challenge?${q}`, { headers: h });
  const j = (await r.json()) as {
    message?: string;
    nonce?: string;
    issuedAt?: string;
    error?: string;
  };
  if (!r.ok || !j.message) {
    throw new Error(j.error || "Could not build wallet challenge");
  }
  return {
    message: j.message,
    nonce: j.nonce || "",
    issuedAt: j.issuedAt || "",
  };
}
